<template>
  <div
    @click.self="close"
    class="modal fade show"
    id="exampleModalCenter"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalCenterTitle">
            Создание расписания
          </h5>
        </div>
        <div class="modal-body">
          <div class="doctor">
            <div class="subtitle">
              {{ doctor.department }} / {{ doctor.specialty }}
            </div>
            <div class="title">{{ doctor.name }}</div>
          </div>
          <form>
            <div class="dates">
              <b-input-group size="sm">
                <template v-slot:prepend>
                  <b-input-group-text>Даты</b-input-group-text>
                </template>
                <b-form-datepicker
                  :date-format-options="dateFormatOptions"
                  :max="endDate"
                  :start-weekday="1"
                  placeholder="Начало"
                  v-model="startDate"
                ></b-form-datepicker>
                <b-form-datepicker
                  :date-format-options="dateFormatOptions"
                  :min="startDate"
                  :start-weekday="1"
                  placeholder="Конец"
                  v-model="endDate"
                ></b-form-datepicker>
              </b-input-group>
            </div>
            <div class="days">
              <div class="label">Дни недели:</div>
              <b-button-group size="sm">
                <b-button
                  v-for="day in daysWeek"
                  :key="day.id"
                  :variant="day.selected ? 'primary' : 'outline-primary'"
                  @click="day.selected = !day.selected"
                >
                  {{ day.name }}
                </b-button>
              </b-button-group>
            </div>
            <div class="time-ranges">
              <div class="title">
                <div class="label">Рабочее время:</div>
                <b-button @click="add()" size="sm" variant="outline-primary">
                  Добавить
                </b-button>
              </div>
              <div class="range" v-for="segment in segments" :key="segment.id">
                <b-input-group size="sm">
                  <template v-slot:prepend>
                    <div>
                      <select style="width:105px" v-model="segment.record_mode">
                        <option :value="0" selected>Свободный</option>
                        <option :value="1">По телефону</option>
                      </select>
                      <span class="floating-label">Тип записи</span>
                    </div>
                    <b-input-group-text>Период</b-input-group-text>
                  </template>
                  <b-form-input
                    v-model="segment.start"
                    placeholder="Начало"
                    type="time"
                  ></b-form-input>
                  <b-form-input
                    v-model="segment.end"
                    placeholder="Конец"
                    type="time"
                  ></b-form-input>
                  <!--
                    <b-form-timepicker :state="segment.valid" minutes-step="15" placeholder="Начало" v-model="segment.start"></b-form-timepicker>
                    <b-form-timepicker :state="segment.valid" minutes-step="15" placeholder="Конец" v-model="segment.end"></b-form-timepicker>
                    -->
                  <template v-slot:append>
                    <b-button
                      :disabled="segments.length === 1"
                      @click="remove(segment.id)"
                      variant="outline-danger"
                    >
                      Удалить
                    </b-button>
                  </template>
                </b-input-group>
              </div>
            </div>
            <div class="delay">
              <div>Длительность приема: {{ interval }} мин.</div>
              <b-input-group prepend="1" append="60" class="mt-3">
                <b-form-input
                  v-model="interval"
                  type="range"
                  min="1"
                  max="60"
                ></b-form-input>
              </b-input-group>
            </div>
            <div class="override">
              <div class="custom-control custom-switch">
                <input
                  v-model="override"
                  type="checkbox"
                  class="custom-control-input"
                  id="overrideSwitch"
                />
                <label class="custom-control-label" for="overrideSwitch">
                  Заменить уже существующие записи
                </label>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <b-button variant="primary" @click="submit()">
            Создать
          </b-button>
          <b-button variant="outline-primary" @click="close()">
            Отменить
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ClickOutside from '../Directives/ClickOutside';

export default {
  props: {
    doctor: Object
  },
  data() {
    return {
      dateFormatOptions: { year: 'numeric', month: 'numeric', day: 'numeric' },
      override: false,
      submitted: false,
      startDate: null,
      endDate: null,
      counter: 0,
      segments: [],
      interval: 15,
      daysWeek: [
        { id: 0, name: 'Пн', selected: true },
        { id: 1, name: 'Вт', selected: true },
        { id: 2, name: 'Ср', selected: true },
        { id: 3, name: 'Чт', selected: true },
        { id: 4, name: 'Пт', selected: true },
        { id: 5, name: 'Сб', selected: false },
        { id: 6, name: 'Вс', selected: false }
      ],
      skip: true
    };
  },
  created() {
    this.add();
  },
  methods: {
    validateDates() {
      // const required = this.startDate !== null && this.endDate !== null;
    },
    validateSegments() {
      this.segments = this.segments.map(s => {
        const required = s.start !== null && s.end !== null;
        if (required) {
          const startTimes = s.start.split(':');
          const endTimes = s.end.split(':');
          const start =
            +startTimes[0] * 60 + +startTimes[1] * 60 + +startTimes[2];
          const end = +endTimes[0] * 60 + +endTimes[1] * 60 + +endTimes[2];
          const valid = end > start;
          return { ...s, valid };
        }
        return { ...s, valid: false };
      });
    },
    async submit() {
      const format = n => (n > 9 ? '' + n : '0' + n);
      const hourOffsetUTC =
        '+' + format(-new Date().getTimezoneOffset() / 60) + ':00';
      const payload = {
        UTC: hourOffsetUTC,
        clear: this.override,
        debug: false,
        doctor: this.doctor.id,
        dates: {
          start: this.startDate,
          end: this.endDate
        },
        weekday: this.daysWeek.filter(d => d.selected).map(d => d.id),
        workhour: this.segments.map(s => {
          const end = s.end;
          const start = s.start;
          const record_mode = s.record_mode;
          return { end, start, record_mode };
        }),
        duration: +this.interval
      };
      this.$emit('success', payload);
    },
    createSegment(id) {
      return { id, start: null, end: null, valid: null, record_mode: 0 };
    },
    add() {
      const segment = this.createSegment(this.counter++);
      this.segments.push(segment);
    },
    remove(id) {
      const index = this.segments.findIndex(s => s.id === id);
      this.segments.splice(index, 1);
    },
    close() {
      this.$emit('close');
    },
    success() {
      this.$emit('success');
    }
  },
  directives: {
    ClickOutside
  }
};
</script>

<style scoped>
.modal {
  display: block;
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.3);
}
.doctor {
  margin-bottom: 24px;
}
.doctor .title {
  font-size: 1.4rem;
  line-height: 1;
}
.doctor .subtitle {
  font-size: 0.9rem;
  color: #616161;
  font-weight: 300;
}
.input-group,
.btn-group,
.input-group > *,
.btn-group > * {
  position: static;
  z-index: auto;
}
.dates,
.days,
.time-ranges {
  margin-bottom: 12px;
}
.time-ranges .range {
  margin-top: 6px;
}
.delay {
  margin-bottom: 12px;
}
.btn-primary:focus,
.btn-outline-primary:focus {
  box-shadow: none;
}
.btn-outline-primary:hover {
  color: #007bff;
  background-color: #fff;
}
::v-deep .dropdown.show {
  z-index: 99999;
}


select:focus ~ .floating-label,
select:not(:focus):valid ~ .floating-label{
 
  font-size: 11px;
  opacity: 1;
}
select {
  font-size: 14px;
  border-bottom: 2px ridge #e9ecef;
  height: 32px;
}

.floating-label {
  position: absolute;
  pointer-events: none;
  color: #007bff;
  left: 30px;
  top: 200px;
  transition: 0.2s ease all;
}
</style>
